import React from 'react';
import PropTypes from 'prop-types';
import { getCountry, COUNTRY_US } from '../../utils/countries';

import './CountryBadge.css';

/**
 * CountryBadge - Shows a small country indicator
 * Only displays for non-US countries to highlight international auctions
 */
const CountryBadge = ({ countryId, showAlways = false }) => {
    // Don't show badge for US auctions unless explicitly requested
    if (!countryId || (countryId === COUNTRY_US && !showAlways)) {
        return null;
    }

    const country = getCountry(countryId);

    return (
        <span className="al-country-badge" title={country.name}>
            {country.code}
        </span>
    );
};

CountryBadge.propTypes = {
    countryId: PropTypes.number,
    showAlways: PropTypes.bool
};

export default CountryBadge;
